export default {
  modulPrefix: "Zusätzlich absichern",
  name: "Naturgewalten Elementar",
  nameMakler: "Elementarschutz",
  body:
    "Der Einschluss dieses Moduls ist für Ihre Adresse online nicht möglich. Bitte kontaktieren Sie unser Beratungsteam telefonisch unter" +
    "<br>" +
    " 040 37663-366.",
  bodyMakler:
    "Online können wir Ihnen kein Angebot erstellen." +
    "<br/><br/>" +
    "Bitte rufen Sie im Maklervertriebscenter unter der Telefonnummer 040 3766 3222 an. Sie erreichen uns von Montag bis Freitag von 8:00 bis 18:00 Uhr.",
};
